<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
        <loading :show="lshow" :label="llabel"> </loading>
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <!-- main row for all icons  -->
            <div class="col-lg-12 justify-content-center">
                <div class="card card-danger card-outline">
                    <div class="card-header">
                        <div class="col-sm-12">
                            <div class="row">
                                <div
                                    class="col-sm-2 center center-block"
                                    align="center"
                                >
                                    <button
                                        class="btn btn-danger"
                                        style="width: 100% !important"
                                        @click="nameMdl"
                                    >
                                        <i class="fa fa-search"></i> Name
                                    </button>
                                </div>
                                &nbsp;
                                <div
                                    class="col-sm-2 center center-block"
                                    align="center"
                                >
                                    <button
                                        class="btn btn-danger"
                                        style="width: 100% !important"
                                        @click="codeMdl"
                                    >
                                        <i class="fa fa-search"></i> Item Code
                                    </button>
                                </div>
                                &nbsp;
                                <div
                                    class="col-sm-2 center center-block"
                                    align="center"
                                >
                                    <button
                                        class="btn btn-danger"
                                        style="width: 100% !important"
                                        @click="billMdl"
                                    >
                                        <i class="fa fa-search"></i> Bill No.
                                    </button>
                                </div>
                                &nbsp;
                                <div
                                    class="col-sm-2 center center-block"
                                    align="center"
                                >
                                    <button
                                        class="btn btn-danger"
                                        style="width: 100% !important"
                                        @click="slMdl"
                                    >
                                        <i class="fa fa-search"></i> Sl/IMEI No.
                                    </button>
                                </div>
                                &nbsp;
                                <div
                                    class="col-sm-2 center center-block"
                                    align="center"
                                >
                                    <button
                                        class="btn btn-danger"
                                        style="width: 100% !important"
                                        @click="jobMdl"
                                    >
                                        <i class="fa fa-search"></i> Old Job
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body overflow-auto">
                        <form @submit.prevent="addJob">
                            <div
                                :class="[
                                    'form-group',
                                    errors.branch ? 'has-error' : '',
                                ]"
                                v-if="
                                    usertype == 'service-admin' ||
                                    usertype == 'installation-admin'
                                "
                            >
                                <label>Branch: *</label>
                                <v-select
                                    v-model="form.branch"
                                    type="text"
                                    label="fullname"
                                    :options="branches"
                                    :reduce="(branches) => branches.branch_code"
                                    placeholder="Select Branch"
                                    :value="(branches) => branches.branch_code"
                                ></v-select>
                                <span
                                    v-if="errors.branch"
                                    :class="['badge bg-danger']"
                                    >Please choose a branch.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.item_name ? 'has-error' : '',
                                ]"
                            >
                                <label>Item Name: *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the item name"
                                    v-model="form.item_name"
                                />
                                <span
                                    v-if="errors.item_name"
                                    :class="['badge bg-danger']"
                                    >Please enter the item name</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.item_code ? 'has-error' : '',
                                ]"
                            >
                                <label>Item Code:</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the item code"
                                    v-model="form.item_code"
                                />
                                <span
                                    v-if="errors.item_code"
                                    :class="['badge bg-danger']"
                                    >Please enter the item code</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.brand ? 'has-error' : '',
                                ]"
                            >
                                <label>Brand: *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the brand"
                                    v-model="form.brand"
                                />
                                <span
                                    v-if="errors.brand"
                                    :class="['badge bg-danger']"
                                    >Please enter the brand</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.model ? 'has-error' : '',
                                ]"
                            >
                                <label>Model: *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the model"
                                    v-model="form.model"
                                />
                                <span
                                    v-if="errors.model"
                                    :class="['badge bg-danger']"
                                    >Please enter the model</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.category ? 'has-error' : '',
                                ]"
                            >
                                <label>Division: *</label>
                                <!--					<v-select v-model="form.category" type="text" label="category" :options="categories" :reduce="categories => categories.category_name" placeholder="Select Item Category" :value="categories => categories.category_name"></v-select>-->
                                <v-select
                                    v-model="form.division"
                                    class="form-control"
                                    type="text"
                                    label="division_name"
                                    :options="divisions"
                                    :reduce="
                                        (divisions) => divisions.division_name
                                    "
                                    name="division"
                                    placeholder="Select Division Category"
                                    :value="
                                        (divisions) => divisions.division_name
                                    "
                                ></v-select>

                                <span
                                    v-if="errors.category"
                                    :class="['badge bg-danger']"
                                    >Please choose category</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.category ? 'has-error' : '',
                                ]"
                                v-if="form.division != ''"
                            >
                                <label>Category: *</label>
                                <!--					<v-select v-model="form.category" type="text" label="category" :options="categories" :reduce="categories => categories.category_name" placeholder="Select Item Category" :value="categories => categories.category_name"></v-select>-->
                                <v-select
                                    v-model="form.category"
                                    class="form-control"
                                    type="text"
                                    label="category_name"
                                    :options="categories"
                                    :reduce="
                                        (categories) => categories.category_name
                                    "
                                    name="category"
                                    placeholder="Select Item Category"
                                    :value="
                                        (categories) => categories.category_name
                                    "
                                ></v-select>

                                <span
                                    v-if="errors.category"
                                    :class="['badge bg-danger']"
                                    >Please choose category</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.category ? 'has-error' : '',
                                ]"
                                v-if="form.category != ''"
                            >
                                <label>Product: *</label>
                                <!--					<v-select v-model="form.category" type="text" label="category" :options="categories" :reduce="categories => categories.category_name" placeholder="Select Item Category" :value="categories => categories.category_name"></v-select>-->
                                <v-select
                                    v-model="form.product"
                                    class="form-control"
                                    type="text"
                                    label="product_name"
                                    :options="products"
                                    :reduce="
                                        (products) => products.product_name
                                    "
                                    name="product"
                                    placeholder="Select Product Category"
                                    :value="(products) => products.product_name"
                                ></v-select>

                                <span
                                    v-if="errors.category"
                                    :class="['badge bg-danger']"
                                    >Please choose category</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.type ? 'has-error' : '',
                                ]"
                            >
                                <label>Type: *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the serial no."
                                    v-model="form.type"
                                />
                                <span
                                    v-if="errors.type"
                                    :class="['badge bg-danger']"
                                    >Please enter the type</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.sl_no ? 'has-error' : '',
                                ]"
                            >
                                <label>Serial No.: *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the serial no."
                                    v-model="form.sl_no"
                                />
                                <span
                                    v-if="errors.sl_no"
                                    :class="['badge bg-danger']"
                                    >Please enter the serial no.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.complaint ? 'has-error' : '',
                                ]"
                            >
                                <label>Complaint: *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the complaint"
                                    v-model="form.complaint"
                                />
                                <span
                                    v-if="errors.complaint"
                                    :class="['badge bg-danger']"
                                    >Please enter the complaint.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.current_condition ? 'has-error' : '',
                                ]"
                            >
                                <label>Current Condition: *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the current condition"
                                    v-model="form.current_condition"
                                />
                                <span
                                    v-if="errors.current_condition"
                                    :class="['badge bg-danger']"
                                    >Please enter the current condition</span
                                >
                            </div>

                            <div
                                :class="[
                                    'form-group',
                                    errors.current_condition ? 'has-error' : '',
                                ]"
                            >
                                <label>Item Images: *</label> &nbsp;
                                <a
                                    @click="updateServiceItemImagesModal"
                                    v-if="
                                        gatepass_id != '' && gatepass_id != null
                                    "
                                    ><span class="btn btn-secondary"
                                        ><b
                                            ><i
                                                class="fa fa-upload"
                                                aria-hidden="true"
                                            ></i>
                                            Upload Images of Item</b
                                        ></span
                                    ></a
                                >
                                <br /><br />
                                <div class="card card-secondary card-outline">
                                    <div class="card-body overflow-auto">
                                        <div class="col-sm-12">
                                            <div class="row">
                                                <div
                                                    class="col-sm-2"
                                                    v-for="img in images"
                                                >
                                                    <img
                                                        :src="img.url"
                                                        width="100"
                                                        height="100"
                                                        @click="
                                                            viewImage(img.url)
                                                        "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span
                                    v-if="errors.current_condition"
                                    :class="['badge bg-danger']"
                                    >Please enter the current condition</span
                                >
                            </div>

                            <div
                                :class="[
                                    'form-group',
                                    errors.accessories_received
                                        ? 'has-error'
                                        : '',
                                ]"
                            >
                                <label>Accessories Received:</label>
                                <div
                                    class="form-check form-check-inline"
                                    v-for="a in accessories"
                                    :key="a.id"
                                >
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        :id="a.accessory"
                                        :value="a.accessory"
                                        v-model="accessories_received"
                                        name="accessory"
                                    />
                                    <label
                                        class="form-check-label"
                                        :for="a.accessory"
                                        >{{ a.accessory }}</label
                                    >
                                </div>
                                <span
                                    v-if="errors.accessories_received"
                                    :class="['badge bg-danger']"
                                    >Please enter the accessories received</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.description ? 'has-error' : '',
                                ]"
                            >
                                <label>Description/Password*:</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the description"
                                    v-model="form.description"
                                />
                                <span
                                    v-if="errors.description"
                                    :class="['badge bg-danger']"
                                    >Please enter the description</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.purchased_year ? 'has-error' : '',
                                ]"
                            >
                                <label>Purchased Date:</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    placeholder="Enter the year of purchase"
                                    v-model="form.purchased_year"
                                />
                                <span
                                    v-if="errors.purchased_year"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid year.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.oxygen_bought ? 'has-error' : '',
                                ]"
                            >
                                <label>Oxygen Bought:</label>
                                <select
                                    class="form-control"
                                    placeholder="Oxygen Bought"
                                    v-model="form.oxygen_bought"
                                >
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                                <span
                                    v-if="errors.oxygen_bought"
                                    :class="['badge bg-danger']"
                                    >Please choose.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.job_category ? 'has-error' : '',
                                ]"
                            >
                                <label>Job Category: *</label>
                                <v-select
                                    placeholder="Job Category"
                                    v-model="form.job_category"
                                    :options="job_categories"
                                    :reduce="
                                        (job_categories) => job_categories.name
                                    "
                                    label="name"
                                ></v-select>
                                <span
                                    v-if="errors.job_category"
                                    :class="['badge bg-danger']"
                                    >Please choose a category.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.purchased_from ? 'has-error' : '',
                                ]"
                            >
                                <label>Purchased From:</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter where the item was purchased from"
                                    v-model="form.purchased_from"
                                />
                                <span
                                    v-if="errors.purchased_from"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid character.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.bill_no ? 'has-error' : '',
                                ]"
                            >
                                <label>Bill No.:</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the bill no."
                                    v-model="form.bill_number"
                                />
                                <span
                                    v-if="errors.bill_no"
                                    :class="['badge bg-danger']"
                                    >Please enter the bill no.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.expected_delivery_date
                                        ? 'has-error'
                                        : '',
                                ]"
                            >
                                <label>Expected Delivery:</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    placeholder="Enter expected delivery date"
                                    v-model="form.expected_delivery_date"
                                />
                                <span
                                    v-if="errors.expected_delivery_date"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid date.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.estimated_cost ? 'has-error' : '',
                                ]"
                            >
                                <label>Estimated Cost:</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    placeholder="Enter the estimated cost"
                                    v-model="form.estimated_cost"
                                    min="1"
                                />
                                <span
                                    v-if="errors.estimated_cost"
                                    :class="['badge bg-danger']"
                                    >Please enter the estimated cost.</span
                                >
                            </div>
                            <label>Job Location:*</label>
                            <br />
                            <div
                                :class="[
                                    'form-check form-check-inline form-group',
                                    errors.job_location ? 'has-error' : '',
                                ]"
                            >
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios12"
                                    id="exampleRadios1"
                                    value="Offsite"
                                    v-model="form.job_location"
                                />
                                <label
                                    class="form-check-label"
                                    for="exampleRadios1"
                                >
                                    Offsite (brought to o2care)
                                </label>
                            </div>

                            <div
                                :class="[
                                    'form-check form-check-inline form-group',
                                    errors.job_location ? 'has-error' : '',
                                ]"
                            >
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios11"
                                    id="exampleRadios1"
                                    value="Onsite"
                                    v-model="form.job_location"
                                />
                                <label
                                    class="form-check-label"
                                    for="exampleRadios1"
                                >
                                    Onsite (Home, other location etc.)
                                </label>
                            </div>
                            <br />
                            <br />
                            <div
                                :class="[
                                    'form-group',
                                    errors.expected_delivery_date
                                        ? 'has-error'
                                        : '',
                                ]"
                            >
                                <button
                                    class="btn btn-danger"
                                    style="width: 100% !important"
                                    type="submit"
                                >
                                    Add Job to System
                                </button>
                            </div>
                            <br />
                            <br />
                        </form>
                    </div>
                    <div class="card-footer"></div>
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="nameModal"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search Using Name</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div
                            class="col-sm-12 align-center center justify-content-center"
                        >
                            <div class="row">
                                <div
                                    class="col-sm-11 align-center center content-center"
                                >
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the brand"
                                            v-model="brand"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-sm-11 align-center center content-center"
                                >
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the model"
                                            v-model="model"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-info"
                                            @click="nameSearch"
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <br />
                                <div
                                    class="col-sm-11 align-center center content-center"
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-success"
                                            >{{ search_status }}</span
                                        >
                                    </div>
                                </div>

                                <br />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label>Choose Item:</label>
                                <v-select
                                    v-model="item"
                                    type="text"
                                    label="ITEM_NAME"
                                    :options="items"
                                    :reduce="(items) => items.ITEM_CODE"
                                    placeholder="Select APX ITEM"
                                    :value="(items) => items.ITEM_CODE"
                                ></v-select>
                            </div>
                            <div class="form-group">
                                <button
                                    class="btn btn-danger"
                                    @click="selectItem"
                                >
                                    Select
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="codeModal"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search Using Item Code</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the item code"
                                            v-model="code"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-info"
                                            @click="codeSearch"
                                        >
                                            Search ERP for Item
                                        </button>
                                    </div>
                                </div>
                                <br />
                                <div class="form-group">
                                    <span class="right badge badge-success">{{
                                        search_status
                                    }}</span>
                                </div>
                                <br />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label>Choose Item:</label>
                                    <v-select
                                        class="form-control"
                                        v-model="item"
                                        type="text"
                                        label="ITEM_NAME"
                                        :options="items"
                                        :reduce="(items) => items.ITEM_CODE"
                                        placeholder="Select APX ITEM"
                                        :value="(items) => items.ITEM_CODE"
                                    ></v-select>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <button
                                        class="btn btn-danger"
                                        @click="selectItem"
                                    >
                                        Select
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="billModal"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search Using Bill No.</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the bill number"
                                            v-model="bill"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="date"
                                            placeholder="Enter the bill date"
                                            v-model="bill_date"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            @click="billSearch"
                                        >
                                            Search ERP for Item
                                        </button>
                                    </div>
                                </div>
                                <br />
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-success"
                                            >{{ search_status }}</span
                                        >
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label>Choose Item:</label>
                                    <v-select
                                        v-model="item"
                                        class="form-control"
                                        type="text"
                                        label="ITEM_NAME"
                                        :options="items"
                                        :reduce="(items) => items.ITEM_CODE"
                                        placeholder="Select APX ITEM"
                                        :value="(items) => items.ITEM_CODE"
                                    ></v-select>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <button
                                        class="btn btn-danger"
                                        @click="selectItem"
                                    >
                                        Select
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="jobModal"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Search Using Previous Job Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter job no./sl no./phone no./item name matching old job"
                                            v-model="job_data"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            @click="jobSearch"
                                        >
                                            Search Data
                                        </button>
                                    </div>
                                </div>
                                <br />
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-success"
                                            >{{ search_status }}</span
                                        >
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label>Choose Item:</label>
                                    <v-select
                                        v-model="job"
                                        class="form-control"
                                        label="job_title"
                                        :options="jobs"
                                        :reduce="(jobs) => jobs.id"
                                        placeholder="Select Job"
                                    ></v-select>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <button
                                        class="btn btn-danger"
                                        @click="selectJob"
                                    >
                                        Select
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="slModal"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search Using Sl\IMEI No.</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the SL/IMEI number"
                                            v-model="imei"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            @click="imeiSearch"
                                        >
                                            Search ERP for Item
                                        </button>
                                    </div>
                                </div>
                                <br />
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-success"
                                            >{{ search_status }}</span
                                        >
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label>Choose Item:</label>
                                    <v-select
                                        v-model="item"
                                        class="form-control"
                                        type="text"
                                        label="ITEM_NAME"
                                        :options="items"
                                        :reduce="(items) => items.ITEM_CODE"
                                        placeholder="Select APX ITEM"
                                        :value="(items) => items.ITEM_CODE"
                                    ></v-select>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <button
                                        class="btn btn-danger"
                                        @click="selectItem"
                                        data-dismiss="modal"
                                    >
                                        Select
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="serviceItemImagesModal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Profile Image</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body overflow-auto">
                        <div class="main">
                            <div
                                class="dropzone-container"
                                @dragover="dragover"
                                @dragleave="dragleave"
                                @drop="drop"
                            >
                                <input
                                    type="file"
                                    multiple
                                    name="file"
                                    id="fileInput"
                                    class="hidden-input"
                                    @change="onChange"
                                    ref="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                />

                                <label for="fileInput" class="file-label">
                                    <div v-if="isDragging">
                                        Release to drop files here.
                                    </div>
                                    <div v-else>
                                        Drop files here or <u>click here</u> to
                                        upload.
                                    </div>
                                </label>
                                <div
                                    class="preview-container mt-4"
                                    v-if="files.length"
                                >
                                    <div
                                        v-for="file in files"
                                        :key="file.name"
                                        class="preview-card"
                                    >
                                        <div>
                                            <img
                                                class="preview-img"
                                                :src="generateURL(file)"
                                            />
                                            <p>
                                                {{ file.name }} -
                                                {{
                                                    Math.round(
                                                        file.size / 1000
                                                    ) + "kb"
                                                }}
                                            </p>
                                        </div>
                                        <div>
                                            <button
                                                class="ml-2"
                                                type="button"
                                                @click="
                                                    remove(files.indexOf(file))
                                                "
                                                title="Remove file"
                                            >
                                                <b>×</b>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <small
                            ><b
                                >Upload square image with you in the center
                                position.</b
                            >
                            Retry only if image hasn't appeared after 5 mins of
                            uploading</small
                        >
                    </div>
                    <div class="card-footer">
                        <button
                            class="btn btn-secondary"
                            @click="uploadServiceItemImages"
                            v-if="files != [] && files != null"
                            data-dismiss="modal"
                        >
                            Upload
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- All VUE Parts end before this comment -->

        <!-- I have a bad feeling about this -->
    </div>
</template>

<script>
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: {
        loading,
    },

    created() {
        this.getAccessories();
        // this.getCategories();
        this.getMasterItemCategories();
        this.getDivisions();
        this.getProductList();
        this.getJobCategories();
        this.getBranches();
        this.getGatepass();
        this.getImages();
        this.usertype = window.user.user_type;
        this.gatepass_id = this.$route.params.gatepass;
    },

    data() {
        return {
            form: new Form({
                item_name: "",
                images: [],
                item_code: "",
                brand: "",
                model: "",
                purchased_year: "",
                category: "",
                division: "",
                product: "",
                type: "",
                expected_delivery_date: "",
                job_category: "",
                oxygen_bought: "",
                bill_number: "",
                sl_no: "",
                complaint: "",
                current_condition: "",
                accessories_received: [],
                purchased_from: "",
                description: "",
                estimated_cost: "",
                imei: "",
                job_location: "",
                gatepass_id: "",
                customer_id: "",
                comm_address: "",
                billing_address: "",
                branch: "",
            }),
            gatepass_id: "",
            errors: [],
            brand: "",
            model: "",
            items: [],
            images: [],
            item: "",
            code: "",
            search_status: "",
            bill: "",
            bill_date: "",
            accessories: [],
            accessories_received: [],
            categories: [],
            divisions: [],
            products: [],
            job_categories: [],
            imei: "",
            lshow: false,
            llabel: "Creating Job...",
            job_data: "",
            job: "",
            jobs: [],
            files: [],
            isDragging: false,
            branches: [],
            gatepass: [],
            history: [],
            ownership: [],

            usertype: "",
            customertype: "",
        };
    },

    methods: {
        getGatepass() {
            axios
                .post("/api/getGatepass", { id: this.$route.params.gatepass })
                .then((response) => {
                    this.gatepass = response.data;
                    this.getGatepassOwnershipHistory();
                    this.getGatepassHistory();
                    // this.history = this.gatepass.gatepass_status_histories;
                    // this.ownership = this.gatepass.gatepass_ownership_histories;
                });
        },

        getGatepassHistory() {
            axios
                .post("/api/getGatepassHistory", { id: this.gatepass.id })
                .then((response) => {
                    this.history = response.data;
                });
        },
        getGatepassOwnershipHistory() {
            axios
                .post("/api/getGatepassOwnershipHistory", {
                    id: this.gatepass.id,
                })
                .then((response) => {
                    this.ownership = response.data;
                });
        },

        getAccessories() {
            axios.post("/api/getAllAccessories").then((response) => {
                this.accessories = response.data;
            });
        },

        updateServiceItemImagesModal() {
            $("#serviceItemImagesModal").modal("show");
        },

        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },

        // getCategories(){
        // 	axios.post("/api/getAllCategories")
        // 	.then(response => {
        // 		this.categories = response.data;
        // 	})
        // },

        getMasterItemCategories() {
            axios.post("/api/getMasterItemCategories").then((response) => {
                this.categories = response.data;
            });
        },

        getDivisions() {
            axios.post("/api/getMasterDivisionList").then((response) => {
                this.divisions = response.data;
            });
        },

        getProductList() {
            axios.post("/api/getMasterProductList").then((response) => {
                this.products = response.data;
            });
        },

        getJobCategories() {
            axios.post("/api/getAllJobCategories").then((response) => {
                this.job_categories = response.data;
            });
        },

        addJob() {
            this.form.accessories_received =
                this.accessories_received.toString();
            this.lshow = true;
            this.form.gatepass_id = this.$route.params.gatepass;
            this.form
                .post("/api/addGatepassJob")
                .then((response) => {
                    if (response.data != null)
                        this.$router.push(
                            "/service/job-profile/" + response.data
                        );
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
            this.lshow = false;
        },

        nameMdl() {
            this.search_status = "";
            $("#nameModal").modal("show");
        },

        codeMdl() {
            this.search_status = "";
            $("#codeModal").modal("show");
        },

        billMdl() {
            this.search_status = "";
            $("#billModal").modal("show");
        },

        slMdl() {
            this.search_status = "";
            $("#slModal").modal("show");
        },

        jobMdl() {
            this.search_status = "";
            $("#jobModal").modal("show");
        },

        getImages() {
            axios
                .post("/api/getImages", {
                    gatepass_id: this.$route.params.gatepass,
                })
                .then((response) => {
                    this.images = response.data;
                });
        },

        nameSearch() {
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            axios
                .post("/api/nameSearch", {
                    brand: this.brand,
                    model: this.model,
                })
                .then((response) => {
                    this.items = response.data;
                    toast.fire({
                        icon: "success",
                        title: "Search Complete",
                    });
                    this.search_status = "Search Complete!";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.search_status = "Search Complete!";
                });
        },

        codeSearch() {
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            axios
                .post("/api/codeSearch", { code: this.code })
                .then((response) => {
                    this.items = response.data;
                    toast.fire({
                        icon: "success",
                        title: "Search Complete",
                    });
                    this.search_status = "Search Complete!";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.search_status = "Search Complete!";
                });
        },

        billSearch() {
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            axios
                .post("/api/billSearch", {
                    bill: this.bill,
                    bill_date: this.bill_date,
                })
                .then((response) => {
                    this.items = response.data;
                    toast.fire({
                        icon: "success",
                        title: "Search Complete",
                    });
                    this.search_status = "Search Complete!";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.search_status = "Search Complete!";
                });
        },

        imeiSearch() {
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            axios
                .post("/api/imeiSearch", { imei: this.imei })
                .then((response) => {
                    this.items = response.data;
                    toast.fire({
                        icon: "success",
                        title: "Search Complete",
                    });
                    this.search_status = "Search Complete!";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.search_status = "Search Complete!";
                });
        },

        jobSearch() {
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            axios
                .post("/api/jobSearch", { data: this.job_data })
                .then((response) => {
                    this.jobs = response.data;
                    toast.fire({
                        icon: "success",
                        title: "Search Complete",
                    });
                    this.search_status = "Search Complete!";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.search_status = "Search Complete!";
                });
        },

        selectJob() {
            var item = this.jobs.find((c) => c.id == this.job);
            this.form.branch = null;
            this.form.fill(item);
        },

        selectItem() {
            var item = this.items.find((c) => c.ITEM_CODE == this.item);
            this.form.item_name = item.ITEM_NAME;
            this.form.item_code = item.ITEM_CODE;
            var name = item.ITEM_NAME.split(":");
            this.form.brand = name[0];
            this.form.type = name[1];
            this.form.model = name[2];
            // this.form.category = item.PROD_CATG_NAME;
            this.form.sl_no = item.ITEM_SERIAL_NOS;

            $("#nameModal").modal("hide");
            $("#codeModal").modal("hide");
            $("#billModal").modal("hide");
        },

        onChange() {
            this.files = [...this.$refs.file.files];
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChange();
            this.isDragging = false;
        },
        remove(i) {
            this.files.splice(i, 1);
        },
        generateURL(file) {
            let fileSrc = URL.createObjectURL(file);
            setTimeout(() => {
                URL.revokeObjectURL(fileSrc);
            }, 1000);
            return fileSrc;
        },
        uploadServiceItemImages() {
            const files = this.files;
            const formData = new FormData();
            // files.forEach((file) => {
            //     formData.append("images", file);
            // });
            // formData.append("gatepass_id", this.gatepass_id);
            for (let i = 0; i < this.files.length; i++) {
                const image = this.files[i];
                formData.append("images[]", image);
                formData.append("gatepass_id", this.gatepass_id);
            }
            axios({
                method: "POST",
                url: "/api/uploadImages",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((response) => {
                    // $("#addDCConfirmModal").modal("hide");
                    toast.fire({
                        icon: "success",
                        title: "Images Added to Upload Queue",
                    });
                    this.llabel = "";
                    this.lshow = false;
                    this.getImages();
                    // $("#DCGeneratedModal").modal("show");
                })
                .catch((errors) => {
                    this.lshow = false;
                    // $("#addDCConfirmModal").modal("hide");
                    toast.fire({
                        icon: "error",
                        title: "Upload Failed!",
                    });
                    this.getImages();
                    this.lshow = false;
                    this.errors = errors.response.data.errors;
                });
        },
    },
};
</script>
